import { StaticPageContent } from 'components/staticPageContent/StaticPageContent';
import { StaticPageProvider } from 'components/staticPageContext/StaticPageProvider';
import type { StaticPageProps } from './staticPageSSRProps';

export const StaticPageRoute = (props: StaticPageProps) => {
  const { handle } = props;

  return (
    <StaticPageProvider handle={handle}>
      <StaticPageContent />
    </StaticPageProvider>
  );
};
